import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PesvPuntosCriticosDesplazamientoPayload {
  desplazamiento_id: number;
  ubicacion: string;
  descripcion?: string | null;
  tipo_punto?: number | null;
  nivel_riesgo?: number | null;
  medida_control?: string | null;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface PesvPuntosCriticosDesplazamiento {
  id?: number;
  desplazamiento_id: number;
  ubicacion: string;
  descripcion?: string | null;
  tipo_punto?: number | null;
  nivel_riesgo?: number | null;
  medida_control?: string | null;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface PesvPuntosCriticosDesplazamientoResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PesvPuntosCriticosDesplazamientoService {
  private readonly apiUrl =
    `${environment.apiUrl}/api/pesv_puntos_criticos_desplazamiento`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los puntos críticos
   */
  getAll(): Observable<PesvPuntosCriticosDesplazamiento[]> {
    return this.http.get<PesvPuntosCriticosDesplazamiento[]>(
      this.apiUrl,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Obtener punto crítico por ID
   */
  getById(
    id: number
  ): Observable<PesvPuntosCriticosDesplazamiento> {
    return this.http.get<PesvPuntosCriticosDesplazamiento>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Obtener puntos críticos por desplazamiento
   */
  getByDesplazamiento(
    desplazamientoId: number
  ): Observable<PesvPuntosCriticosDesplazamiento[]> {
    return this.http.get<PesvPuntosCriticosDesplazamiento[]>(
      `${this.apiUrl}/desplazamiento/${desplazamientoId}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear punto crítico
   */
  create(
    payload: PesvPuntosCriticosDesplazamientoPayload
  ): Observable<PesvPuntosCriticosDesplazamientoResponse> {
    return this.http.post<PesvPuntosCriticosDesplazamientoResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar punto crítico
   */
  update(
    id: number,
    payload: Partial<PesvPuntosCriticosDesplazamientoPayload>
  ): Observable<PesvPuntosCriticosDesplazamientoResponse> {
    return this.http.put<PesvPuntosCriticosDesplazamientoResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar punto crítico
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar punto crítico
   */
  inactivar(
    id: number
  ): Observable<PesvPuntosCriticosDesplazamientoResponse> {
    return this.http.put<PesvPuntosCriticosDesplazamientoResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar punto crítico
   */
  activar(
    id: number
  ): Observable<PesvPuntosCriticosDesplazamientoResponse> {
    return this.http.put<PesvPuntosCriticosDesplazamientoResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}